// extracted by mini-css-extract-plugin
export default {"price":"Ona-z","onSale":"Pna-z","msrpLabelPrice":"Qna-z","msrpLabel":"Rna-z","originalPrice":"Sna-z"};